import React, { Component } from 'react';
 

interface Iprops{
    predSearchToggle,
    predSearchResponse,
    togglePredSearch,
    assignPredSearchQues
}

interface Istate {
  myRef
}

class PredSearch extends Component<Iprops, Istate,null> {
  
    constructor(props){
      super(props);
      this.state = {
        myRef: React.createRef()
      }
    }

    
    moveFocus() {
      const node = this.state.myRef.current;
      if(node != null){
        node.addEventListener('keydown', function(e) {
          const active = document.activeElement;
          if(!active.nextSibling || !active.nextSibling ) {
       
          }
          if(e.keyCode === 40) {
            console.log(active.nextSibling);
            // active.nextSibling.focus()
          }
          if(e.keyCode === 38) {
            console.log(active.previousSibling);
            // active.previousSibling.focus()
          }
        });
      }
    }
    componentDidUpdate(){
      this.moveFocus();
    }

    render() {
        return (
            this.props.predSearchToggle ? (
                <div className="auto-suggestions-block" ref={this.state.myRef}>
                  <span className="each-suggestion">
                    {this.props.predSearchResponse &&
                      this.props.predSearchResponse.search
                        .slice(0, 5)
                        .map((data, index) => {
                          return (
                            <a
                              key={index}
                              onClick={this.props.assignPredSearchQues}
                              className="each-suggestion"
                              href="#"
                            >
                              {data.q}
                            </a>
                          );
                        })}
                  </span>
                </div>
            ) : ("")
        )
    }
}

export default PredSearch;